import React from "react";
import styled from "styled-components";

export default function HeadlessCMSDescription() {
  return (
    <ul>
      <ListItem>
        <b>Responsive Design:</b> The blog is fully responsive, ensuring an
        optimal viewing experience across all devices, from mobile phones to
        desktops.
      </ListItem>
      <ListItem>
        <b>SEO-Friendly:</b> features like dynamic meta tags and optimized
        loading for better search engine visibility.
      </ListItem>
      <ListItem>
        <b>Content Management with Contentful:</b> All blog content, including
        posts, images, and metadata, is dynamically fetched from the Contentful
        headless CMS.
      </ListItem>
      <ListItem>
        <b>Users can add comments to blog posts</b>
      </ListItem>
    </ul>
  );
}

const ListItem = styled.li`
  list-style-type: none;
  margin-bottom: 8px;
`;
